import type { FilterOption } from '@/components/filters/filter-menu'

export type PipelineBoardSort = 'score' | 'newest'

export const PIPELINE_BOARD_SORT_LABELS: Record<PipelineBoardSort, string> = {
  score: 'Highest score',
  newest: 'Newest first',
}

export const PIPELINE_BOARD_SORT_OPTIONS: FilterOption[] = (
  Object.keys(PIPELINE_BOARD_SORT_LABELS) as PipelineBoardSort[]
).map((key) => ({
  value: key,
  label: PIPELINE_BOARD_SORT_LABELS[key],
}))

export function parsePipelineBoardSort(value: string): PipelineBoardSort {
  return value === 'newest' ? 'newest' : 'score'
}
